var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94198 11.0911C10.2512 11.4004 10.7641 11.4004 11.0733 11.0911C11.3826 10.7819 11.3826 10.269 11.0733 9.95976L7.11359 6L11.0734 2.04024C11.3826 1.731 11.3826 1.21811 11.0733 0.90887C10.7641 0.599629 10.2512 0.599629 9.94198 0.90887L5.98222 4.86863L2.02238 0.908793C1.71314 0.599552 1.20026 0.599553 0.891014 0.908794C0.581772 1.21804 0.581772 1.73092 0.891013 2.04016L4.85085 6L0.891013 9.95983C0.581772 10.2691 0.581772 10.782 0.891013 11.0912C1.20025 11.4004 1.71314 11.4004 2.02238 11.0912L5.98222 7.13137L9.94198 11.0911Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuit);
export default __webpack_public_path__ + "static/media/quit.a0f24072a0ce134b98e5921d88aa17ac.svg";
export { ForwardRef as ReactComponent };